import { AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';
import type { EditorNotice } from '@/ports/editor';
import { IconButton } from '../IconButton';

export function NoticeBar({ notice, onClose }: { readonly notice: EditorNotice; readonly onClose: () => void }) {
  const Icon = notice.kind === 'error' || notice.kind === 'warning' ? AlertTriangle : notice.kind === 'success' ? CheckCircle2 : Info;
  return (
    <div className={`notice-bar notice-bar--${notice.kind}`} role={notice.kind === 'error' ? 'alert' : 'status'}>
      <Icon aria-hidden="true" size={18} />
      <span>{notice.message}</span>
      <IconButton icon={X} label="Cerrar aviso" onClick={onClose} />
    </div>
  );
}
